var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScissors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91356 9.41423L13.166 12.6667M8.49935 8.00002L13.166 3.33335M8.49935 8.00002L6.58023 9.91914M8.49935 8.00002L6.58023 6.0809M6.58023 9.91914C6.2183 9.55721 5.7183 9.33335 5.16602 9.33335C4.06145 9.33335 3.16602 10.2288 3.16602 11.3334C3.16602 12.4379 4.06145 13.3334 5.16602 13.3334C6.27059 13.3334 7.16602 12.4379 7.16602 11.3334C7.16602 10.7811 6.94216 10.2811 6.58023 9.91914ZM6.58023 6.0809C6.94216 5.71897 7.16602 5.21897 7.16602 4.66669C7.16602 3.56212 6.27059 2.66669 5.16602 2.66669C4.06145 2.66669 3.16602 3.56212 3.16602 4.66669C3.16602 5.77126 4.06145 6.66669 5.16602 6.66669C5.7183 6.66669 6.2183 6.44283 6.58023 6.0809Z",
    stroke: "#9900CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissors);
export default __webpack_public_path__ + "static/media/Scissors.b1c2702a16749a962b5a6a284f22847b.svg";
export { ForwardRef as ReactComponent };